import { ConfigurationOverride } from 'baseui/helpers/overrides';
import { Spinner } from 'baseui/spinner';
import { TrashSVG } from 'common/assets';
import stylesColors from 'common/styles/styles.colors';
import { Button } from 'components/elements/buttons';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  disabled?: boolean;
  onClick?: () => void;
  rootStyle?: ConfigurationOverride;
  style?: React.CSSProperties;
  isLoading?: boolean;
  text?: string;
  icon?: React.ReactNode;
}

export default function DeleteButton(props: Props) {
  const { t } = useTranslation();
  return (
    <Button
      style={props.style}
      onClick={() => {
        !props.disabled && props.onClick?.();
      }}
      buttonType="secondary"
      disabled={props.isLoading}
      overrides={{
        Root: {
          style: {
            height: '100%',
            color: stylesColors.redDefault,
            borderColor: stylesColors.redDefault,
            ...props.rootStyle,
            ':hover': {
              backgroundColor: stylesColors.redLightest,
              borderColor: stylesColors.redLightest,
            },
            ':active': {
              backgroundColor: stylesColors.redLighter,
              borderColor: stylesColors.redLightest,
            },
            ':focus': {
              backgroundColor: stylesColors.redLighter,
              borderColor: stylesColors.redLightest,
            },
          },
        },
      }}
      startEnhancer={(color, size) =>
        props.isLoading ? (
          <Spinner $size={24} $color={stylesColors.redDefault} />
        ) : (
          props.icon ?? (
            <TrashSVG
              color={stylesColors.redDefault}
              width={size}
              height={size}
            />
          )
        )
      }
    >
      {props.text || t('common:delete')}
    </Button>
  );
}
